import React = require('react');
import { imgPath } from '../../../../common/utilities/ImgUrl';
import { TextLinkWidget, TextLinkKind } from '@tableau/widgets';
import { TooltipDraftIndicatorStyles } from '../../../../drafts/styles/DraftStyles';

export interface TooltipDraftIndicatorProps {
    indicatorText: () => string;
    linkText: () => string;
    linkURL: string;
}

export class TooltipDraftIndicator extends React.PureComponent<TooltipDraftIndicatorProps> {
    public render() {
        return (
            <div id="draft-edits-indicator" className={TooltipDraftIndicatorStyles.ContainerStyle}>
                <img
                    tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
                    src={imgPath('info_normal.svg')}
                    className={TooltipDraftIndicatorStyles.IconStyle}
                    data-tb-test-id="draft-indicator-icon"
                />
                <div className={TooltipDraftIndicatorStyles.TextStyle}>
                    {`${this.props.indicatorText()} `}
                    <TextLinkWidget
                        href={this.props.linkURL}
                        target="_blank"
                        testId="draft-continue-editing"
                        kind={TextLinkKind.Standard}
                    >
                        {this.props.linkText()}
                    </TextLinkWidget>
                </div>
            </div>
        );
    }
  }